import { ContractorHeroImage } from "assets/images";
import {
  ContractorHero720Webp,
  ContractorHero1200Webp,
  ContractorHero2468Webp,
  ContractorHero720Png,
  ContractorHero1200Png,
  ContractorHero2468Png,
} from "assets/images";
import {
  FaqSection,
  FeatureSection,
  HeroSection,
  OngoingProjectSection,
  PartnerSection,
} from "components";
import { features } from "./constants";

interface Prop {
  isConsultant?: boolean;
}
export const ContractorPage = ({ isConsultant }: Prop) => {
  return (
    <>
      <HeroSection
        title="Gain Access to Bid on a Steady Pool of Construction Projects"
        subtitle="Sign up and get your company's profile in front of hundreds of project owners for free."
        imageSrc={ContractorHero1200Png}
        imageWebpSrcSet={[
          `${ContractorHero720Webp} 720w`,
          `${ContractorHero1200Webp} 1200w`,
          `${ContractorHero2468Webp} 2468w`,
        ].join(", ")}
        imageFallbackSrcSet={[
          `${ContractorHero720Png} 720w`,
          `${ContractorHero1200Png} 1200w`,
          `${ContractorHero2468Png} 2468w`,
        ].join(", ")}
        imageWidth={2468}
        imageHeight={1472}
      />
      <PartnerSection />
      <FeatureSection features={features} />
      <OngoingProjectSection />
      <FaqSection />
    </>
  );
};
